import {GAME_TYPES} from "../../constants/game";

/**
 * Действует ли экономический бонус игрока (см. configs/playerBonus).
 *
 * Исторически бонус был чисто локальной настройкой. Теперь его же получают
 * «явные» боты рейтинговых матчей (см. configs/visibleRankedBots) и все игроки
 * обычного сетевого лобби, где создатель выбрал бонус (см. utils/lobby/lobbyBonus),
 * поэтому условие смотрит не только на режим игры, но и на самого игрока.
 *
 * Признак берется с игрока, а не из режима: так бонус одинаково применяется и в
 * сетевом матче, и при просмотре его записи (в реплее gameType = REPLAY), и
 * состояние реплея не расходится с оригиналом.
 */
export const checkIfPlayerBonusApplies = (player, gameType) =>
  gameType === GAME_TYPES.LOCAL || Boolean(player && (player.isVisibleBot || player.hasLobbyBonus));
